export default __webpack_public_path__ + "static/gs-full-solution-45865c6bfe9d62a353ed8846e98b1e0e.svg";